(function ($) {
  "use strict";
  $(document).ready(function () {
    
    fetch('https://metals-service.onrender.com/api/metalCosts').then(res=>res.json()).then(kn_price_result => {
      
      var gold = kn_price_result['payload']['Gold'];
      var silver = kn_price_result['payload']['Silver'];
      var platinum = kn_price_result['payload']['Platinum'];
      var palladium = kn_price_result['payload']['Palladium'];
      var copper = kn_price_result['payload']['Copper'];
      var rhodium = kn_price_result['payload']['Rhodium'];
      
      
    
      $('.kn-gold-ch span').text( gold['price'] );     
      
      if( gold['number'] > 0 ){
        $('.kn-gold-ch').addClass('kn-positive-change');      
      }else{
        $('.kn-gold-ch').addClass('kn-nagative-change');    
      }
      
      
      $('.kn-silver-ch span').text( silver['price'] );
      
      if( silver['number'] > 0 ){
        $('.kn-silver-ch').addClass('kn-positive-change');      
      }else{
        $('.kn-silver-ch').addClass('kn-nagative-change');    
      }
      
      
      $('.kn-platinum-ch span').text( platinum['price'] );
      
      if( platinum['number'] > 0 ){
        $('.kn-platinum-ch').addClass('kn-positive-change');      
      }else{
        $('.kn-platinum-ch').addClass('kn-nagative-change');    
      }
      
      $('.kn-palladium-ch span').text( palladium['price'] );
      
      if( palladium['number'] > 0 ){
        $('.kn-palladium-ch').addClass('kn-positive-change');      
      }else{
        $('.kn-palladium-ch').addClass('kn-nagative-change');    
      }
      
      $('.kn-copper-ch span').text( copper['price'] );
      
      if( copper['number'] > 0 ){
        $('.kn-copper-ch').addClass('kn-positive-change');      
      }else{
        $('.kn-copper-ch').addClass('kn-nagative-change');    
      }
      
      $('.kn-rhodium-ch span').text( rhodium['price'] );

      if( rhodium['number'] > 0 ){
        $('.kn-rhodium-ch').addClass('kn-positive-change');      
      }else{
        $('.kn-rhodium-ch').addClass('kn-nagative-change');    
      }
    });
    
  });
  
}(jQuery));

